/* 🤖 this file was generated by svg-to-ts */
export const matIconTheaters: {
  name: 'theaters';
  data: string;
} = {
  name: 'theaters',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm6 10h-4V5h4v14zm4-2h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"/></svg>`
};
